import React from "react";

import SVGSprite from "@/components/Atoms/SVGSprite";

import { classNameGenerator } from "@/utils";

import styles from "./DownloadPDFSuccess.module.scss";
import Typography from "@/foundation/Typography/V2";

interface DownloadPDFSuccessProps {
  title?: string;
  mobile?: string;
  email?: string;
}

const DownloadPDFSuccess: React.FC<DownloadPDFSuccessProps> = ({
  title,
  mobile,
  email,
}) => {
  const cls = classNameGenerator(styles);

  return (
    <div className={cls("successWrapper")}>
      <SVGSprite className={cls("icon")} icon="icon-check-success" />
      <Typography className={cls("title")} variant="heading3">
        Thank you for submitting your details.
      </Typography>
      <Typography
        className={cls("description")}
        variant="paragraph1"
        dangerouslySetInnerHTML={{
          __html:
            mobile && email
              ? `We will share the guide to ${title} on your WhatsApp & email &#128513;`
              : mobile
              ? `We will share the guide to ${title} on your WhatsApp &#128513;`
              : `We will share the guide to ${title} on your Email &#128513;`,
        }}
      />
    </div>
  );
};

export default DownloadPDFSuccess;
